export const mapInsurerRolesToSelectOptions = function (roles) {
    return roles.map(role => ({
        text: role,
        value: role,
    }));
};
